var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { TextField } from './TextField';
import { forwardRef, useRef } from 'react';
import { CrossIcon } from './icons/CrossIcon';
import { IconButton } from './IconButton';
export var ClearableTextField = forwardRef(function (_a, forwardedRef) {
    var onKeyDown = _a.onKeyDown, onChange = _a.onChange, value = _a.value, id = _a.id, as = _a.as, props = __rest(_a, ["onKeyDown", "onChange", "value", "id", "as"]);
    var localRef = useRef();
    var ref = forwardedRef || localRef;
    return (jsx("div", { sx: {
            position: 'relative',
        } },
        jsx(TextField, __assign({}, props, { ref: ref, onKeyDown: onChange
                ? function (e) {
                    if (onKeyDown) {
                        onKeyDown(e);
                    }
                    if (!e.defaultPrevented &&
                        e.key === 'Escape' &&
                        value &&
                        onChange) {
                        e.stopPropagation();
                        e.preventDefault();
                        onChange({ target: { value: '' } });
                    }
                }
                : onKeyDown, onChange: onChange, value: value, id: id, autoComplete: "off" })),
        !!value && (jsx(IconButton, { sx: {
                position: 'absolute',
                right: 0,
                top: 0,
                height: '100%',
                px: 2,
                display: 'flex',
                flexDirection: 'column',
            }, onClick: onChange
                ? function () {
                    onChange({ target: { value: '' } });
                    ref.current.focus();
                }
                : undefined },
            jsx(CrossIcon, { "aria-label": "Clear", sx: {
                    my: 'auto',
                } })))));
});
//# sourceMappingURL=ClearableTextField.js.map